import * as React from "react";
import { MonthDivider, MonthDividerInfo } from "burde";
import { useResources } from "contexts/resource-context";
import * as cn from "classnames/bind";
import * as styles from "./month-divider-picker.css";

type MonthDividerPickerProps = {
    onClick: (monthDivider: MonthDividerInfo | null) => void;
    monthDividers: MonthDivider[];
    selected: MonthDividerInfo | null;
};

const MonthDividerPicker = ({
    onClick,
    monthDividers,
    selected,
}: MonthDividerPickerProps) => {
    const cx = cn.bind(styles);

    const resource = useResources();

    const iconPickerCs = () =>
        cx({
            iconPicker: true,
            iconPickerSmall: false,
            iconPickerWithHeader: false,
        });

    const iconPickerLiCn = () =>
        cx({
            iconPickerLi: true,
            iconPickerLiSmall: false,
        });

    const iconPickerItemCn = (isSelected: boolean) =>
        cx({
            iconPickerItem: true,
            iconPickerItemSmall: false,
            iconPickerItemImageAuto: true,
            iconPickerItemSelected: isSelected,
        });

    const iconPickerContent = () =>
        cx({
            content: true,
        });

    const iconPickerTextWrapper = () =>
        cx({
            iconPickerTextWrapper: true,
        });

    const iconPickerTitle = () =>
        cx({
            iconPickerTitle: true,
        });

    const iconPickerDescription = () =>
        cx({
            iconPickerDescription: true,
        });

    const checkboxCn = () =>
        cx({
            checkBoxWrap: true,
        });

    const checkBoxSpanCn = (isChecked: boolean) =>
        cx({
            checkBoxWrapSpan: true,
            checkBoxWrapSpanSelected: isChecked,
            fas: isChecked,
            "fa-check": isChecked,
        });

    return (
        <ul className={iconPickerCs()}>
            {monthDividers.map((monthDivider) => (
                <li
                    className={iconPickerLiCn()}
                    key={monthDivider.id}
                    onClick={() => {
                        selected !== null &&
                        selected.layoutId === monthDivider.id
                            ? onClick(null)
                            : onClick({
                                  layoutId: monthDivider.id,
                                  showFrame:
                                      selected !== null
                                          ? selected.showFrame
                                          : false,
                              });
                    }}>
                    <div
                        className={iconPickerItemCn(
                            selected !== null &&
                                selected.layoutId === monthDivider.id,
                        )}>
                        <div className={iconPickerContent()}>
                            <span className={iconPickerTitle()}>
                                {monthDivider.title ? monthDivider.title : ""}
                            </span>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html:
                                        monthDivider.endpoints.thumbnail || "",
                                }}></div>
                            <div className={iconPickerTextWrapper()}>
                                <p className={iconPickerDescription()}>
                                    {monthDivider.description}
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default MonthDividerPicker;
